/**
 * Append a streaming chunk to existing content while avoiding duplicate overlaps
 * that can occur due to network retries or server-side replays of tail fragments.
 *
 * Strategy:
 * 1. If existing already endsWith full chunk, ignore (pure duplicate)
 * 2. Find largest suffix of existing that is a prefix of chunk (overlap)
 * 3. Append only the non-overlapping remainder
 */
export function appendStreamingChunk(existing: string, chunk: string): string {
  if (!chunk) return existing;
  if (existing.endsWith(chunk)) return existing; // full duplicate
  const maxOverlap = Math.min(existing.length, chunk.length, 100); // limit search window for perf
  for (let k = maxOverlap; k > 0; k--) {
    if (existing.slice(-k) === chunk.slice(0, k)) {
      return existing + chunk.slice(k);
    }
  }
  return existing + chunk;
}

/**
 * Normalize whitespace artifacts that sometimes appear when chunks boundary-split
 * mid-word or with leading spaces. This can be called after assembling text.
 */
export function normalizeStreamingContent(text: string): string {
  // Collapse 3+ spaces to 1, but preserve double spaces (e.g., after period) by a simple rule
  return text.replace(/ {3,}/g, '  ');
}
